// 사용자 환경설정에서 허용되는 값 목록의 정본. 클라이언트(테마 적용·드롭다운),
// 서버(user_preference 저장 시 검증), drizzle 스키마($type) 가 전부 여기를 참조해야
// 값이 하나 늘어날 때 한쪽만 고치고 넘어가는 사고를 막는다.
//
// apps/app/src/lib/theme.ts 는 모듈 최상위에서 window.matchMedia 를 부르므로 서버가
// import 할 수 없다 — 그래서 "값 목록"만 여기로 내리고 적용 로직은 그대로 둔다.
// (apps/app/index.html 의 첫 페인트 인라인 스크립트는 어떤 모듈도 import 할 수 없어
//  값을 손으로 복제한다. 팔레트를 추가하면 거기도 같이 확인할 것.)

/** 밝기 모드. "system" 은 OS 설정을 따른다. */
export const APPEARANCE_PREFERENCES = ["system", "light", "dark"] as const;
export type AppearancePreference = (typeof APPEARANCE_PREFERENCES)[number];

/** 색상 팔레트. 각각 라이트·다크 버전을 가진다(정의는 apps/ui/src/styles/globals.css). */
export const THEME_PALETTES = [
  "default",
  "sepia",
  "midnight",
  "forest",
  "ocean",
  "rose",
] as const;
export type ThemePalette = (typeof THEME_PALETTES)[number];
